<template>
            <!-- partial:partials/_sidebar.html -->
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
            <li class="nav-item">
                <router-link class="nav-link active" to="/">
                <i class="icon-grid menu-icon"></i>
                <span class="menu-title">Dashboard</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" to="/citizens">
                <i class="icon-head menu-icon"></i>
                <span class="menu-title">House Hold and Others</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" to="/ward">
                    <i class="fa-solid fa-people-roof" style="margin-right: 15px;font-size: 16px;"></i>                
                    <span class="menu-title">Ward</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" to="/road">
                    <i class="fa-solid fa-road" style="margin-right: 18px;"></i>                
                    <span class="menu-title">Road</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" to="/block">
                    <i class="fa-solid fa-users" style="margin-right: 15px;font-size: 16px;"></i>
                    <span class="menu-title">Block</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" to="/nirmal-sathi">
                    <i class="fa-solid fa-users" style="margin-right: 15px;font-size: 16px;"></i>
                    <span class="menu-title">Nirmal Sathi</span>
                </router-link>
            </li>
        </ul>
    </nav>
    <!-- partial -->
</template>